const init = () => {
  const contactForms = document.querySelectorAll('.umbraco-forms-form form');

  if (contactForms.length) {
    contactForms.forEach(form => {
      setPostData(form);
    });
  }
};

const setPostData = (el) => {
  const url = el.querySelector('input[data-alias=url]');
  url.value = window.location.href;

  const fullNameField = el.querySelector('input.name');

  if (fullNameField) {
    fullNameField.addEventListener('change', function () {
      const fullName = fullNameField.value;
      if (fullName.length > 0) {
        const nameParts = fullName.split(' ');
        let lastNameStartIndex = 0;

        if (nameParts.length > 1) {
          const firstNameField = el.querySelector('input[data-alias=first_name]');
          const firstNameMaxLength = 40;
          const firstName = nameParts[0];
          const firstNameLength = firstName.length;
          lastNameStartIndex = firstNameLength + 1;
          firstNameField.value = (firstNameLength > firstNameMaxLength) ? firstName.substring(0, firstNameMaxLength) : firstName;
        }

        const lastNameField = el.querySelector('input[data-alias=last_name]');
        const lastNameMaxLength = 80;
        const lastName = fullName.substring(lastNameStartIndex);
        const lastNameLength = lastName.length;
        lastNameField.value = (lastNameLength > lastNameMaxLength) ? lastName.substring(0, lastNameMaxLength) : lastName;
      }
    });
  }
}

const contactForms = {
  init,
};

export default contactForms;
